import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, Download } from 'lucide-react';
import type { Annotation } from '@/types';

interface SummaryViewerProps {
  summary: Annotation;
}

export function SummaryViewer({ summary }: SummaryViewerProps) {
  const isImported = summary.annotation_metadata?.source === 'imported_summary';

  return (
    <Card className="border-blue-200 dark:border-blue-800 bg-blue-50/50 dark:bg-blue-950/20">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <FileText className="h-5 w-5" />
          Document Summary
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="prose prose-sm max-w-none dark:prose-invert">
          <div className="whitespace-pre-wrap text-sm leading-relaxed">
            {summary.content}
          </div>
        </div>
        
        {isImported && (
          <div className="flex items-center gap-2 text-sm text-blue-600 dark:text-blue-400 bg-blue-100 dark:bg-blue-900/30 px-3 py-2 rounded-md">
            <Download className="h-4 w-4" />
            <span>Imported from existing summary file</span>
          </div>
        )}
        
        {summary.confidence !== undefined && (
          <div className="text-xs text-muted-foreground">
            Confidence: {Math.round(summary.confidence * 100)}%
          </div>
        )}
      </CardContent>
    </Card>
  );
}
